import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { GridDetails, GridEvent } from '../interfaces/grid';
import { UrlBuilder } from '../../../core';
import { ActivityLogger } from '../../../activities/activity-logger';
import { IBreadcrumb, BreadcrumbService } from '../../shared/breadcrumb-service/breadcrumb.service';
import { SubjectSearchService } from './../subject-search-overview/subject-search-service';
import { VisitSampleListRequest, PatientDetails, SubjectSearchData } from '../interfaces/subject-search-data';

@Component({
    selector: 'subject-visit-details',
    template: require('./subject-details.component.html'),
    styles: [require('./subject-details.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectVisitDetailsComponent {

    public headerLabel = '';
    public sampleSearchData: SubjectSearchData[] = [];
    public gridDetails: GridDetails;
    public isLoadingCompleted = false;
    public resultCount = 0;
    public pagePerItems = [15, 25, 50, 75, 100, 250, 500];
    public patientDetails: PatientDetails = {};
    public emptyPlaceholder = '';

    constructor(
        private sampleTrackingStorage: SampleTrackingStorage,
        private changeDectRef: ChangeDetectorRef,
        private urlBuilder: UrlBuilder,
        private activityLogger: ActivityLogger,
        private breadcrumbService: BreadcrumbService,
        private subjectSearchService: SubjectSearchService
    ) {
        let requestData = localStorage.getItem('visitSampleListRequest');
        if (!requestData) { return; }
        let subjectRequestData: VisitSampleListRequest = JSON.parse(requestData);
        let routerUrl: IBreadcrumb = {
            label: 'Patient ' + subjectRequestData.patientNumber + ' Visit Details',
            url: this.urlBuilder.esa().sampletracking().subjectVisitDetails(subjectRequestData.patientNumber).url()
        };
        this.headerLabel = 'Visits for ' + subjectRequestData.patientNumber;
        this.breadcrumbService.AddRouterToBreadCrumb(routerUrl);
        this.sampleTrackingStorage.visitBySubjectID(subjectRequestData).subscribe((results: SubjectSearchData[]) => {
            this.sampleSearchData = results;
            this.gridDetails = { header: this.subjectSearchService.subjectVisitHeader, data: results };
            this.resultCount = results.length > 0 ? results.length : this.resultCount;
            if (results.length === 0) {
                this.emptyPlaceholder = 'No Visits found for Patient Number - ' + subjectRequestData.patientNumber;
            }
            this.setPatientDetails(subjectRequestData.data);
            this.isLoadingCompleted = true;
            this.changeDectRef.markForCheck();
        });
        activityLogger.logActivity('Access Subject - Visit Details');
    }

    public onGridItemClick($event: GridEvent) {
        this.subjectSearchService.visitSampleGridItemClick($event);
    }

    private setPatientDetails(results: SubjectSearchData) {
        if (!results) { return; }
        this.patientDetails = {
            protocol: results.protocolCode,
            projectNumber: results.projectNumber,
            investigatorName: results.investigatorName,
            investigatorNumber: results.investigatorNumber,
            screeningNumber: results.screeningNumber,
            dateOfBirth: results.birthDate,
            age: results.displayAge,
            country: results.country
        };
    }
}